module.exports = __webpack_public_path__ + "static/media/roshan-title.ba668b0e.jpg";